import { Link, useLocation } from 'react-router-dom';

export function PublicNav() {
  const { pathname } = useLocation();
  const isLogin = pathname === '/login';

  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b border-neutral-100 bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-5">
        <Link to="/" className="flex items-center gap-2.5">
          <img src="/logo.png" alt="iHeart CNTRL" className="size-9 object-contain" />
          <span className="text-base font-bold text-neutral-800">
            iHeart <span className="bg-gradient-to-r from-pink-500 to-indigo-500 bg-clip-text text-transparent">CNTRL</span>
          </span>
        </Link>
        <nav className="flex items-center gap-4">
          <Link
            to="/"
            className="text-sm font-medium text-neutral-500 transition-colors hover:text-neutral-800"
          >
            Home
          </Link>
          <Link
            to="/#pricing"
            className="text-sm font-medium text-neutral-500 transition-colors hover:text-neutral-800"
          >
            Pricing
          </Link>
          <Link
            to={isLogin ? '/register' : '/login'}
            className="rounded-lg bg-gradient-to-r from-pink-500 to-indigo-500 px-4 py-1.5 text-sm font-semibold text-white transition-opacity hover:opacity-90"
          >
            {isLogin ? 'Register Free' : 'Sign in'}
          </Link>
        </nav>
      </div>
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="w-full px-4 py-2.5 sm:px-8 sm:py-3">
      <div className="flex flex-col items-center gap-0.5 text-center text-[10px] leading-tight text-neutral-400 sm:text-[11px]">
        <span>
          &copy; {new Date().getFullYear()} iHeart CNTRL — a product of{' '}
          <a
            href="https://iheartdigital.co.za"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-neutral-500 underline decoration-neutral-300 underline-offset-2 transition-colors hover:text-pink-500 hover:decoration-pink-400"
          >
            iHeart Digital
          </a>
          {' '}&middot; Reg. 2026/453657/07
        </span>
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5">
          <a href="/terms-and-conditions/" className="transition-colors hover:text-neutral-600">
            Terms of Service
          </a>
          <span>·</span>
          <a href="/privacy-policy/" className="transition-colors hover:text-neutral-600">
            Privacy Policy
          </a>
          <span>·</span>
          <a href="/returns-and-refunds/" className="transition-colors hover:text-neutral-600">
            Returns &amp; Refunds
          </a>
        </div>
      </div>
    </footer>
  );
}
